
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

export default function AboutPage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      <section className="pt-32 pb-24 bg-gradient-to-br from-slate-50 to-slate-100">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="text-center mb-16">
            <h1 className="text-5xl md:text-6xl font-bold text-slate-800 mb-6">
              Quiénes Somos
            </h1>
            <p className="text-xl text-slate-600 max-w-3xl mx-auto leading-relaxed">
              Institución financiera comprometida con el desarrollo económico de personas y empresas en Latinoamérica
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-20">
            <div>
              <div className="w-full h-96 rounded-2xl overflow-hidden">
                <img 
                  src="https://public.readdy.ai/ai/img_res/042f453696b56b86a0d424a5f90b61b6.jpg" 
                  alt="Novacréditos Oficinas"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>
            <div>
              <h2 className="text-3xl font-bold text-slate-800 mb-6">Nuestra Historia</h2>
              <p className="text-slate-600 mb-4 leading-relaxed">
                Fundada en 2010, <strong>Novacréditos</strong> nace con la visión de democratizar el acceso a servicios financieros profesionales en Latinoamérica. Con más de 15 años de experiencia, nos hemos consolidado como una institución de confianza en Chile, Perú y México.
              </p>
              <p className="text-slate-600 mb-4 leading-relaxed">
                Nuestra trayectoria está respaldada por más de <strong>$2.5 mil millones de dólares en créditos otorgados</strong> y la confianza de más de <strong>50,000 clientes satisfechos</strong> que han cumplido sus metas personales y empresariales con nuestro apoyo.
              </p>
              <p className="text-slate-600 leading-relaxed">
                Operamos bajo estrictos estándares de cumplimiento normativo, supervisados por las autoridades financieras de cada país: CMF en Chile, SBS en Perú y CNBV en México.
              </p>
            </div>
          </div>

          <div className="bg-white rounded-2xl p-12 shadow-sm mb-20">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
              <div>
                <div className="w-16 h-16 bg-gradient-to-br from-emerald-500 to-teal-600 rounded-xl flex items-center justify-center mb-6">
                  <i className="ri-eye-fill text-white text-3xl"></i>
                </div>
                <h3 className="text-2xl font-bold text-slate-800 mb-4">Nuestra Visión</h3>
                <p className="text-slate-600 leading-relaxed">
                  Ser la plataforma financiera digital líder en Latinoamérica, reconocida por nuestra excelencia en servicio, innovación tecnológica y compromiso con el desarrollo económico sostenible de nuestros clientes.
                </p>
              </div>
              <div>
                <div className="w-16 h-16 bg-gradient-to-br from-emerald-500 to-teal-600 rounded-xl flex items-center justify-center mb-6">
                  <i className="ri-compass-fill text-white text-3xl"></i>
                </div>
                <h3 className="text-2xl font-bold text-slate-800 mb-4">Nuestra Misión</h3>
                <p className="text-slate-600 leading-relaxed">
                  Proporcionar soluciones financieras accesibles, transparentes y seguras que impulsen el crecimiento personal y empresarial, manteniendo los más altos estándares de profesionalismo, ética y cumplimiento normativo.
                </p>
              </div>
            </div>
          </div>

          <div className="mb-20">
            <h2 className="text-3xl font-bold text-slate-800 mb-12 text-center">Nuestros Valores</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
              {[
                { icon: 'ri-shield-check-fill', title: 'Confianza', desc: 'Construimos relaciones duraderas basadas en transparencia y honestidad' },
                { icon: 'ri-user-heart-fill', title: 'Compromiso', desc: 'Dedicados al éxito financiero de cada uno de nuestros clientes' },
                { icon: 'ri-lightbulb-fill', title: 'Innovación', desc: 'Tecnología de vanguardia para simplificar procesos financieros' },
                { icon: 'ri-scales-fill', title: 'Integridad', desc: 'Cumplimiento estricto de normativas y estándares éticos' },
              ].map((value, index) => (
                <div key={index} className="bg-slate-50 rounded-xl p-8 text-center hover:shadow-lg transition-shadow">
                  <div className="w-14 h-14 bg-gradient-to-br from-emerald-500 to-teal-600 rounded-lg flex items-center justify-center mx-auto mb-4">
                    <i className={`${value.icon} text-white text-2xl`}></i>
                  </div>
                  <h4 className="text-lg font-bold text-slate-800 mb-3">{value.title}</h4>
                  <p className="text-sm text-slate-600 leading-relaxed">{value.desc}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="bg-gradient-to-br from-emerald-600 to-teal-700 rounded-2xl p-12 text-white text-center">
            <h2 className="text-3xl font-bold mb-6">Certificaciones y Regulaciones</h2>
            <p className="text-emerald-50 mb-8 max-w-2xl mx-auto leading-relaxed">
              Operamos bajo supervisión de las principales autoridades financieras y mantenemos certificaciones internacionales de seguridad
            </p>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6 border border-white/20">
                <i className="ri-government-fill text-4xl mb-3"></i>
                <h4 className="font-bold mb-2">Regulación Financiera</h4>
                <p className="text-sm text-emerald-50">CMF, SBS, CNBV</p>
              </div>
              <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6 border border-white/20">
                <i className="ri-shield-star-fill text-4xl mb-3"></i>
                <h4 className="font-bold mb-2">ISO 27001</h4>
                <p className="text-sm text-emerald-50">Seguridad de la Información</p>
              </div>
              <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6 border border-white/20">
                <i className="ri-lock-fill text-4xl mb-3"></i>
                <h4 className="font-bold mb-2">SSL 256-bit</h4>
                <p className="text-sm text-emerald-50">Cifrado Bancario</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
